export const getHistoryData = ({history}) => {
    return history.history;
  };